// API endpoints
const baseApiDomain = process.env.NUXT_ENV_API_ENDPOINT
const baseApiUrl = `${baseApiDomain}/api`
const apiVersion = '/v1'
const baseApiUrlVersioned = baseApiUrl + apiVersion

// AUTH endpoints
const baseAuthDomain = process.env.NUXT_ENV_AUTH_ENDPOINT
const baseAuthUrl = `${baseAuthDomain}/api`
const localStorageTokenKey = 'auth._token.local'
const loginPath = `${baseAuthUrl}/login`
const logoutPath = `${baseAuthUrl}/logout`
const fetchProfilePath = `${baseAuthUrl}${apiVersion}/user.json`

// MEDIA endpoints
const baseMediaDomain = process.env.NUXT_ENV_MEDIA_ENDPOINT

export {
  // API
  baseApiDomain, baseApiUrl, apiVersion, baseApiUrlVersioned,
  // AUTH
  baseAuthDomain, baseAuthUrl, localStorageTokenKey, loginPath, logoutPath, fetchProfilePath,
  // MEDIA
  baseMediaDomain
}

export default {
  // API
  baseApiDomain, baseApiUrl, apiVersion, baseApiUrlVersioned,
  // AUTH
  baseAuthDomain, baseAuthUrl, localStorageTokenKey, loginPath, logoutPath, fetchProfilePath,
  // MEDIA
  baseMediaDomain
}